import {fromEvent, Observable}       from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';

import * as KeyCodes from '../../../../Shared/Constants/KeyCodes';
import Frame         from '../../Frame/Frame';

/**
 * Creates an observable stream which emits when the frame is
 * focused and the space bar is pressed.
 */

const createKeypressSpaceStream = (
    target: EventTarget,
    frameStoreUpdate$: Observable<Frame>
): Observable<Event> =>
    fromEvent(target, 'keypress')
        .pipe(
            withLatestFrom(frameStoreUpdate$),
            filter(([e, {isFocused}]) => (e as KeyboardEvent).keyCode === KeyCodes.SPACE && isFocused),
            map(([e]) => e)
        );

export default createKeypressSpaceStream;